import ObjectHash from 'object-hash'

export const state = () => {
	return {
		brandingVipLevels: [],
		ttl_branding: null,
		cache_duration_branding: 3600000, // 1 hour
		cache_key_branding: '',
		rewardsByLevelId: {},
		cacheKeyRewardsByLevelId: '',
		ttlRewardsByLevelId: null,
	}
}

function isInCacheBranding(state, companyId) {
	if (state.cache_key_branding !== buildCacheKeyBranding(companyId)) {
		return false
	}
	if (state.ttl_branding === null || state.ttl_branding < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyBranding(companyId) {
	return `company:${companyId}:branding-vip-level`
}

function isInCacheRewardsByLevelId(state, companyId, levelIds) {
	if (state.cacheKeyRewardsByLevelId !== buildCacheKeyRewardsByLevelId(companyId, levelIds)) {
		return false
	}
	if (state.ttlRewardsByLevelId === null || state.ttlRewardsByLevelId < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyRewardsByLevelId(companyId, levelIds) {
	return `company:${companyId}:branding-vip-levels-rewards:${ObjectHash(levelIds)}`
}

export const actions = {
	async list({ state, commit }, { companyId }) {
		if (isInCacheBranding(state, companyId)) {
			return state.brandingVipLevels
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-vip-levels/`)
			.then((res) => {
				commit('setBranding', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('invalidateCache')
				throw err
			})
	},

	retrieveLevelsRewards({ commit }, { companyId, levelIds }) {
		if (isInCacheRewardsByLevelId(state, companyId, levelIds)) {
			return
		}
		commit('setCacheRewardsByLevelId', { companyId, levelIds })
		for (const levelId of levelIds) {
			useNuxtApp()
				.$api(`api/company/${companyId}/rewards/?level_id=${levelId}`)
				.then((rewards) => {
					commit('setRewardsByLevelId', { levelId, rewards })
				})
				.catch((err) => {
					commit('clearCacheRewardsByLevelId')
					throw err
				})
		}
	},

	async partialUpdate(
		{ commit, dispatch },
		{ companyId, brandingVipLevelId, data, reload = true },
	) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-vip-levels/${brandingVipLevelId}/`, {
				method: 'PATCH',
				body: data,
			})
			.then(async () => {
				commit('invalidateCache')
				if (reload) {
					return await dispatch('list', { companyId })
				}
			})
			.catch((err) => {
				commit('invalidateCache')
				throw err
			})
	},
}

export const mutations = {
	setBranding(state, { data, companyId }) {
		state.brandingVipLevels = data
		state.ttl_branding = Date.now() + state.cache_duration_branding
		state.cache_key_branding = buildCacheKeyBranding(companyId)
	},

	invalidateCache(state) {
		state.ttl_branding = null
	},

	setRewardsByLevelId(state, { levelId, rewards }) {
		state.rewardsByLevelId[levelId] = rewards
	},

	setCacheRewardsByLevelId(state, { companyId, levelIds }) {
		state.ttlRewardsByLevelId = Date.now() + state.cache_duration_branding
		state.cacheKeyRewardsByLevelId = buildCacheKeyRewardsByLevelId(companyId, levelIds)
	},

	invalidateCacheRewardsByLevelId(state) {
		state.ttlRewardsByLevelId = null
	},
}
